import type {
  DailyShiftSlotRepository,
  ImportResult,
} from './ports/DailyShiftSlotRepository';

export interface ImportShiftSlotsInput {
  year: number;
  month: number;
  csvData: string;
}

export interface ImportShiftSlotsOutput {
  success: boolean;
  importedCount: number;
  errors: string[];
}

/**
 * CSVからシフト枠をインポートするUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input ImportShiftSlotsInput インポートデータ
 * @returns Promise<ImportShiftSlotsOutput> インポート結果
 */
export async function importShiftSlots(
  repository: DailyShiftSlotRepository,
  input: ImportShiftSlotsInput
): Promise<ImportShiftSlotsOutput> {
  try {
    const result: ImportResult = await repository.importCsv(
      input.year,
      input.month,
      input.csvData
    );
    return {
      success: result.success,
      importedCount: result.importedCount,
      errors: result.errors,
    };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'インポートに失敗しました';
    return {
      success: false,
      importedCount: 0,
      errors: [errorMessage],
    };
  }
}
